import { Component, Input, signal } from '@angular/core';
import { EFeeType, IPortfolioFeeConfigsInfo } from 'src/models/products.model';

@Component({
  selector: 'liberro-regular-deposit-fee-info',
  templateUrl: './regular-deposit-fee-info.component.html',
  styleUrls: ['./regular-deposit-fee-info.component.less'],
  standalone: false
})

export class RegularDepositfeeInfoComponent {
  @Input({ required: true }) public feeConfig!: IPortfolioFeeConfigsInfo;

  public readonly EFeeType = EFeeType;

  public tooltipVisible = signal<boolean>(false);

  public onTooltipHide(event: Event): void {
    event.stopPropagation();
    this.tooltipVisible.set(false);
  }

  public tooltipToggle(flag: boolean): void {
    this.tooltipVisible.set(flag);
  }
}
